import { render, staticRenderFns } from "./ShopRegisterStatus.vue?vue&type=template&id=0d6c4350"
import script from "./ShopRegisterStatus.vue?vue&type=script&lang=js"
export * from "./ShopRegisterStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports